exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_object-gops.js
// module id = 40
// module chunks = 0